import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { GlobalHttpClient } from '../global.http.client';
import { ISearchService } from './search.service';
import { Observable } from 'rxjs';
import { CompetitorSearchModel, CompetitorDto, CurrentCompetitorsSearchModel } from '../models/competitors/competitor.models';
import { IPage } from '../models/common/paging';

@Injectable()
export class CompetitorService extends BaseService implements ISearchService<CompetitorSearchModel, CompetitorDto> {
    constructor(http: GlobalHttpClient) {
        super(http);
    }

    search(request: CompetitorSearchModel): Observable<IPage<CompetitorDto>> {
        return this.http.post<IPage<CompetitorDto>>('competitors/searchCompanyNames', request);
    }

    searchCompanyNames(request: CompetitorSearchModel): Observable<IPage<CompetitorDto>> {
        return this.http.post<IPage<CompetitorDto>>('competitors/searchCompanyNames', request);
    }

    //getCompetitors(request: CompetitorSearchModel): Observable<IPage<CompetitorDto>> {
    //    return this.http.post<IPage<CompetitorDto>>('competitors/getCompetitors', request);
    //}

    getCompetitors() {
        return this.http.get<string[]>('competitors/getCompetitorsList');
    }

    getAwardsForSupplier() {
        return this.http.get(`competitors/getAwardsForSupplier`);
    }

    getAwardsForCompany(companyName: string) {
        return this.http.get(`competitors/getAwardsForCompany/${companyName}`);
    }

    add(companyName: string) {
        //const variable = encodeURIComponent(`${companyName}`);
        var competitorDto = new CompetitorDto();
        competitorDto.name = companyName;

        var result = this.http.post('competitors/add', competitorDto);
        return result;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/competitor.service.ts